import React from 'react';
import { useTranslate } from 'react-admin';
import { Button } from '@mui/material';
import ServiceAddIcon from '@/assets/icons/service-add-icon.svg?react';
import { usePopoverContext } from '@/components/global/buttons/CustomMorePopover';

const CreateServiceRequestButton = ({ onClick, label }) => {
    const translate = useTranslate();
    const { closePopover } = usePopoverContext();
    const buttonLabel = label || translate('resources.device.labels.createServiceRequest');
    return (
        <Button
            onClick={() => {
                onClick();
                closePopover();
            }}
        >
            <ServiceAddIcon /> {buttonLabel}
        </Button>
    );
};

export default CreateServiceRequestButton;
